export default __webpack_public_path__ + "static/media/Villancico.56c53d0d.mp3";